import { GET_DEEPFAKE_CONFIG_ASYNC, UPDATE_DEEPFAKE_CONFIG_ASYNC } from './constants'

export const getDeepfakeConfig = () => ({
  type: GET_DEEPFAKE_CONFIG_ASYNC.INITIATE,
})
export const getDeepfakeConfigSuccess = (data) => ({
  type: GET_DEEPFAKE_CONFIG_ASYNC.SUCCESS,
  payload: { data },
})
export const getDeepfakeConfigError = (error) => ({
  type: GET_DEEPFAKE_CONFIG_ASYNC.ERROR,
  error,
})

export const updateDeepfakeConfig = (key) => ({
  type: UPDATE_DEEPFAKE_CONFIG_ASYNC.INITIATE,
  payload: { key },
})

export const updatePopupAudience = (value) => ({
  type: UPDATE_DEEPFAKE_CONFIG_ASYNC.INITIATE,
  payload: { key: 'popupAudience', value },
})
export const updateDeepfakeConfigSuccess = () => ({
  type: UPDATE_DEEPFAKE_CONFIG_ASYNC.SUCCESS,
})
export const updateDeepfakeConfigError = (error) => ({
  type: UPDATE_DEEPFAKE_CONFIG_ASYNC.ERROR,
  error,
})

// Consent management actions
export const updateConsentText = (text) => ({
  type: UPDATE_DEEPFAKE_CONFIG_ASYNC.INITIATE,
  payload: { key: 'consentText', value: text },
})

export const updateConsentLink = (link) => ({
  type: UPDATE_DEEPFAKE_CONFIG_ASYNC.INITIATE,
  payload: { key: 'consentLink', value: link },
})

export const updateConsentTimeout = (timeout) => ({
  type: UPDATE_DEEPFAKE_CONFIG_ASYNC.INITIATE,
  payload: { key: 'consentTimeoutAmountInSeconds', value: timeout },
})

export const updateJoinExternalMeetings = (isEnabled) => ({
  type: UPDATE_DEEPFAKE_CONFIG_ASYNC.INITIATE,
  payload: { key: 'joinExternalMeetings', value: isEnabled },
})

export const updateEmailAlertsForInternalsInExternalMeetings = (isEnabled) => ({
  type: UPDATE_DEEPFAKE_CONFIG_ASYNC.INITIATE,
  payload: { key: 'emailAlertsForInternalsInExternalMeetings', value: isEnabled },
})

export const updateConsentSettings = (consentText, consentLink) => ({
  type: UPDATE_DEEPFAKE_CONFIG_ASYNC.INITIATE,
  payload: {
    key: 'consentSettings',
    value: { consentText, consentLink },
  },
})

export const updateConsentDataSettings = (consentType, text, link) => ({
  type: UPDATE_DEEPFAKE_CONFIG_ASYNC.INITIATE,
  payload: {
    key: 'consentDataSettings',
    value: { consentType, text, link },
  },
})

export const updateConsentType = (consentType) => ({
  type: UPDATE_DEEPFAKE_CONFIG_ASYNC.INITIATE,
  payload: { key: 'consentType', value: consentType },
})

// MFA Challenge actions
export const updateMfaEnabled = (isEnabled) => ({
  type: UPDATE_DEEPFAKE_CONFIG_ASYNC.INITIATE,
  payload: { key: 'mfaEnabled', value: isEnabled },
})

export const updateMfaLinkTimeoutSeconds = (seconds) => ({
  type: UPDATE_DEEPFAKE_CONFIG_ASYNC.INITIATE,
  payload: { key: 'mfaLinkTimeoutSeconds', value: seconds },
})

export const updateMfaGlobalTimerSeconds = (seconds) => ({
  type: UPDATE_DEEPFAKE_CONFIG_ASYNC.INITIATE,
  payload: { key: 'mfaGlobalTimerSeconds', value: seconds },
})

export const updateMfaSuspicionAlertEnabled = (isEnabled) => ({
  type: UPDATE_DEEPFAKE_CONFIG_ASYNC.INITIATE,
  payload: { key: 'mfaSuspicionAlertEnabled', value: isEnabled },
})

export const updateMfaFailureAlertEnabled = (isEnabled) => ({
  type: UPDATE_DEEPFAKE_CONFIG_ASYNC.INITIATE,
  payload: { key: 'mfaFailureAlertEnabled', value: isEnabled },
})

// SIEM events action
export const updateSiemEventsEnabled = (isEnabled) => ({
  type: UPDATE_DEEPFAKE_CONFIG_ASYNC.INITIATE,
  payload: { key: 'siemEventsEnabled', value: isEnabled },
})

export default {
  // to props
}
